module.exports = __webpack_public_path__ + "img/typinggame.d6546e52.jpg";